import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Radio } from 'components/Form/Radio/Radio';
import { Spinner } from 'components/UI/Spinner/Spinner';
import React from 'react';

import classes from './RadioAvatarCard.module.scss';

interface RadioAvatarCardProps {
    checked?: boolean;
    alt?: string;
    avatar?: string;
    icon?: IconProp;
    label?: string;
    loading?: boolean;
    className?: string;
    description?: string | React.ReactNode;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioAvatarCard: React.FC<RadioAvatarCardProps> = props => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    const triggerChange = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    return (
        <div
            className={clsx(classes.root, props.className, {
                [classes.checked]: props.checked,
                [classes.disabled]: props.loading
            })}
            onClick={triggerChange}
        >
            <Radio
                ref={inputRef}
                checked={props.checked}
                onChange={props.onChange}
                className={classes.input}
            />

            <div className={classes.avatarContainer}>
                {props.avatar && <img src={props.avatar} alt="avatar" className={classes.avatar} />}

                {props.icon && <FontAwesomeIcon icon={props.icon} className={classes.icon} />}
            </div>

            <div>
                {props.label && <p className={classes.label}>{props.label}</p>}
                {props.description && <p className={classes.description}>{props.description}</p>}
            </div>

            {props.loading && (
                <div className={classes.loading}>
                    <Spinner />
                </div>
            )}
        </div>
    );
};
